module.exports = function() {
  return new Worker(__webpack_public_path__ + "164853fcf4e4a6628cf3.worker.js");
};